export default {
  API_ERROR: "Omlouváme se, něco se pokazilo. Zkuste to prosím znovu.",
  FORM_ERROR: "Omlouváme se, ale musíte napsat trochu víc, abyste nám poskytli zpětnou vazbu."
}
